import { AppContext, getToken } from '@ctsu/loader';
import { HelpContainer } from '@ctsu/react-ctsu-ui';
import React, { useContext } from 'react';

function HelpTopics({ contextKey }) {
  const context = useContext(AppContext);
  const { application } = context;
  const authenticated = context && !!getToken();
  if (authenticated) {
    return (
      <HelpContainer
        appUrl={process.env.REACT_APP_ORIGIN}
        getToken={getToken}
        appName={application.appName}
        appContext={contextKey}
      />
    );
  }
  return null;
}

export default HelpTopics;

